import { PodcastsFront } from './components/PodcastsFront';

new PodcastsFront();